import { initializeApp } from 'firebase/app';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Firebase configuration - you'll need to replace with your actual config
// You can use environment variables for different environments
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Functions
const functions = getFunctions(app);

// Initialize Firebase Auth
const auth = getAuth(app);

// Initialize Firestore
const db = getFirestore(app);

// Connect to emulator in development mode
if (import.meta.env.DEV) {
  console.log('🔧 Connecting to Firebase Functions emulator...');
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('🔧 Connecting to Firestore emulator...');
  connectFirestoreEmulator(db, 'localhost', 8080);
  console.log('🔧 Connecting to Auth emulator...');
  connectAuthEmulator(auth, 'http://localhost:9099');
}

// Export for use in components
export { app, functions, auth, db };

// Export config for debugging purposes
export { firebaseConfig }; 